module.exports = __webpack_public_path__ + "static/media/marcela-vila-nova.cde08487.webp";